import { graphql } from "@/shared/gql";
import { useSuspenseQuery } from "@apollo/client";
import { useEffect } from "react";
import { syncLocaleFromMe } from "@/features/language/lib/sync-locale-from-me";

const FetchMeQuery = graphql(/* GraphQL */ `
  query FetchMeQuery {
    me {
      id
      ...AllMeProps
    }
  }
`);

export const useFetchMeQuery = () => {
  const result = useSuspenseQuery(FetchMeQuery);
  const locale = result.data?.me?.locale;

  useEffect(() => {
    if (locale) syncLocaleFromMe(locale);
  }, [locale]);

  if (result.error) {
    throw result.error;
  }

  if (!result.data?.me) {
    throw new Error("Me not found");
  }

  return result.data.me;
};
